import { FC } from 'react';

const Eyes: FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="10" viewBox="0 0 19 10" fill="none">
      <path
        d="M14.459 9.06837C16.967 9.06837 19.0001 7.03835 19.0001 4.53419C19.0001 2.03003 16.967 0 14.459 0C11.9511 0 9.91797 2.03003 9.91797 4.53419C9.91797 7.03835 11.9511 9.06837 14.459 9.06837Z"
        fill="white"
      />
      <path
        d="M12.9034 7.10905C14.3276 7.10905 15.4821 5.95628 15.4821 4.53426C15.4821 3.11225 14.3276 1.95947 12.9034 1.95947C11.4792 1.95947 10.3247 3.11225 10.3247 4.53426C10.3247 5.95628 11.4792 7.10905 12.9034 7.10905Z"
        fill="#030303"
      />
      <path
        d="M11.3629 4.66583C11.7928 4.66583 12.1413 4.31784 12.1413 3.88858C12.1413 3.45932 11.7928 3.11133 11.3629 3.11133C10.933 3.11133 10.5845 3.45932 10.5845 3.88858C10.5845 4.31784 10.933 4.66583 11.3629 4.66583Z"
        fill="white"
      />
      <path
        d="M4.54106 9.06837C7.04902 9.06837 9.08212 7.03835 9.08212 4.53419C9.08212 2.03003 7.04902 0 4.54106 0C2.03311 0 0 2.03003 0 4.53419C0 7.03835 2.03311 9.06837 4.54106 9.06837Z"
        fill="white"
      />
      <path
        d="M2.98543 7.10905C4.4096 7.10905 5.56412 5.95628 5.56412 4.53426C5.56412 3.11225 4.4096 1.95947 2.98543 1.95947C1.56126 1.95947 0.406738 3.11225 0.406738 4.53426C0.406738 5.95628 1.56126 7.10905 2.98543 7.10905Z"
        fill="#030303"
      />
      <path
        d="M1.51036 4.66583C1.94028 4.66583 2.28879 4.31784 2.28879 3.88858C2.28879 3.45932 1.94028 3.11133 1.51036 3.11133C1.08045 3.11133 0.731934 3.45932 0.731934 3.88858C0.731934 4.31784 1.08045 4.66583 1.51036 4.66583Z"
        fill="white"
      />
    </svg>
  );
};

export default Eyes;
